import { createContext } from "react";

export const BookingContext = createContext({});